import React from "react";
import { ExpandedAccordion } from "../../../../shared/components/ui/ExpandedAccordion";
import { StatusBadge } from "../../../../shared/components/badges/StatusBadge";

const stripHtml = (html) => {
  if (!html) return "—";

  // Step 1: Decode HTML entities
  const decoded = new DOMParser().parseFromString(html, "text/html").documentElement.textContent;

  // Step 2: Strip tags
  const clean = new DOMParser().parseFromString(decoded, "text/html").body.textContent;

  return clean?.trim() || "—";
};

const vaccineExpandRow = ({ item }) => {
  const sections = [
    {
      id: "vaccine",
      title: "Vaccine Information",
      fields: [
        { label: "Vaccine Name", value: item.name || "—" },
        { label: "Vaccine Type", value: item.vaccineType || "—" },
        { label: "Vial Type", value: item.vialType || "—" },
        {
          label: "Age Group",
          value: (() => {
            const labels = Array.isArray(item.ageGroupLabel)
              ? item.ageGroupLabel
              : item.ageGroupLabel
              ? item.ageGroupLabel.split(',').map(s => s.trim())
              : [];
            if (labels.length === 0) return '—';
            return (
              <div className="flex flex-wrap gap-1">
                {labels.map((label, idx) => (
                  <span
                    key={idx}
                    className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                  >
                    {label}
                  </span>
                ))}
              </div>
            );
          })(),
        },
        { label: "Dosage", value: item.dosage || "—" },
        { label: "Dosage Unit", value: item.dosageUnits || "—" },
        { label: "Description", value: stripHtml(item.description), isLong: true, isHtml: true },
        { label: "Side Effects", value: stripHtml(item.sideEffects), isLong: true, isHtml: true },
        { label: "Notes", value: stripHtml(item.notes), isLong: true, isHtml: true },
      ],
    },
    {
      id: "dosage",
      title: "Dosage Information",
      fields: [
        { label: "Dosage per Child", value: item.dosagePerChild || "—" },
        { label: "Doses per Vial", value: item.dosagePerVial || "—" },
        { label: "Children per Vial", value: item.childrenPerVial || "—" },
        { label: "Number of Doses", value: item.dosageCount || "—" },
        { label: "Interval Between Doses", value: item.intervalBetweenDoses ? `${item.intervalBetweenDoses} days` : "—" },
      ],
    },
    // {
    //   id: "dates",
    //   title: "Manufacturing & Expiry Dates",
    //   fields: [
    //     {
    //       label: "Manufacturing Date",
    //       value: item.manufacturingDate ? new Date(item.manufacturingDate).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—",
    //     },
    //     {
    //       label: "Expiry Date",
    //       value: item.expiryDate ? new Date(item.expiryDate).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—",
    //     },
    //   ],
    // },
    {
      id: "stock",
      title: "Stock & Storage",
      fields: [
        { label: "Stock Quantity", value: item.totalStock ? `${item.totalStock} units` : "—" },
        { label: "Status", value: <StatusBadge status={item.status || "active"} /> },
        { label: "Storage Location", value: item.storageLocation || "—" },
        { label: "Temperature Range (°C)", value: item.temperature || "—" },
        { label: "Storage Conditions", value: item.storageCondition || "—", isLong: true },
      ],
    },
  ];

  return <ExpandedAccordion sections={sections} />;
};

export default vaccineExpandRow;
